import React from 'react';
import './mypro.css';

const ListProject = () => {
const projects = [{
  id: 1,
  title: "Professional Info Card Design HTML CSS Complete Tutorial with Source Code (2026)- Codingwithssr",
  img: "/Professional-Card-Info-Design-sivaraj47.github.io.png",
  url: "https://sivaraj47.github.io/professional-info-card-design/",
  brief: "Create Stunning Responsive Card Layouts in Minutes Free Template and Code Looking to create professional eye catching info cards for your website This comprehensive tutorial walks you through building a fully responsive card design using pure HTML and CSS with Flexbox. Perfect for blogs portfolios service showcases and modern web applications.",
  tech: "HTML5, CSS3, Flexbox",
  livedemo: "Live Demo and Source Code View Live Demo Technologies HTML5 CSS3 Flexbox Author- Sivasundararaj (codingwithssr) Difficulty- Beginner to Intermediate Build Time- 15-20 minutes",
  features: [
    "What You will Build A modern professional card layout featuring",
    "Three responsive info cards with images",
    "Hover effects with smooth transitions",
    "Mobile first responsive design",
    "Clean Flexbox layout system",
    "Professional typography with Google Fonts",
    "Drop shadow effects for visual depth",
    "Perfect for blogs portfolios and business sites",
  ]
}];


  return (
    <div id="project">
  {projects.map((project) => (
        <div className="listideas" key={project.id}>
          <h1>{project.title}</h1>

          <div className="listboxs">
            <a
              href={project.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={project.img}
                className="imgbox"
                alt={`${project.title} preview - CodingWithSSR`}
              />
            </a>

            <p>{project.brief}</p>

            <h3>Technology Stack: {project.tech}</h3>

            <ul>
              {project.features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>

            <p className="live-demo">{project.livedemo}</p>
          </div>
        </div>
      ))}

      <iframe
  loading="lazy"
  src="https://www.youtube.com/embed/mw5wKG4cSWA"
  title="Professional Info Card Design Tutorial - CodingWithSSR Web Development Trichy"
  frameBorder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  allowFullScreen
  className="ytvideo"
/>
    </div>
  );
};

export default ListProject;
